export const MAX_RETRY_ATTEMPTS = 2;
export const RETRY_STATUS = [401];
export const RETRY_DELAYS = [0, 100, 200];

export const MAX_RETRY_ERROR_CODE = 'MAX_RETRY_ERROR';
export const MAX_RETRY_ERROR_MESSAGE = 'Max fetch retry attempts reached';
